<style>
    .upload {
      font-weight: bold;
      color: #28a745;
      margin-left: 15px;
      line-height: 36px;
    }
  
    .uploadbtn {
      width: 83px;
      height: 33px;
      padding: 1px 4px;
      margin-top: 24px;
      font-size: 13px;
    }
  
    .download {
      color: red;
      font-size: 20px;
      border: none
    }
  
    table {
      background-color: white;
    }
  
    .filegroup {
      font-size: 11px;
      font-weight: 500;
    }
  
    .form {
      width: 655px;
    }
  
    .required {
      color: red
    }
  </style>
  <form novalidate [formGroup]="docuploadForm" class="form">
    <div class="row" *ngIf="!IsViewPage">
      <div class="col-md-6">
        <div class="form-group">
          <label for="validfrom" class="control-label">Document Type <span class="required">*</span></label>
          <kendo-dropdownlist #ddl="" popupAnchor [defaultItem]="{ value: null, text: 'Select Document Type' }"
            [data]="FileGroupList" textField="text" valueField="value" [filterable]="true" required
            [kendoDropDownFilter]="filterSettings" [valuePrimitive]="true" [formControl]="docuploadForm.get('filegroup')">
          </kendo-dropdownlist>
          <div *ngFor="let validation of validations.message.isRequired">
            <div class="k-tooltip k-tooltip-validation"
              *ngIf="docuploadForm.get('filegroup').hasError(validation.type) && (docuploadForm.get('filegroup').dirty || docuploadForm.get('filegroup').touched)">
              Please Select Document Type
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="IsViewDoc">
        <div class="form-group">
          <label for="documentid" class="control-label">Document ID No. <span class="required">*</span></label>
          <input type="text" class="k-textbox" formControlName="documentid" style="width: 173px;"
            (keyup)="changestart($event.target.value)" required/>
          <div *ngFor="let validation of validations.message.isRequired">
            <div class="k-tooltip k-tooltip-validation left46" *ngIf="docuploadForm.get('documentid').hasError(validation.type)
             && (docuploadForm.get('documentid').dirty || docuploadForm.get('documentid').touched)">
              Please Enter Document Id Number
            </div>
          </div>
          <div class="k-tooltip k-tooltip-validation" *ngIf="docuploadForm.get('documentid').hasError('maxlength')">
            Max Length of Document ID No. should be 30.
          </div>
          <div class="k-tooltip k-tooltip-validation" *ngIf="docuploadForm.get('documentid').hasError('minlength')">
            Min Length of Document ID No. should be 1.
          </div>
          <div class="k-tooltip k-tooltip-validation"
            *ngIf="docuploadForm.get('documentid').hasError('uniquecheckerror')">
            Please enter unique Document ID No.
          </div>
          <div class="k-tooltip k-tooltip-validation" *ngIf="docuploadForm.get('documentid').hasError('whitespace')">
            Must contain only letters and numbers with spaces in between & all Special characters
          </div>
          <div class="k-tooltip k-tooltip-validation" *ngIf="docuploadForm.get('documentid').hasError('LastCharError')">
            Must contain only letters and numbers with spaces in between & all Special characters
          </div>
  
        </div>
      </div>
    </div>
    <div class="row" *ngIf="IsViewDoc && !IsViewPage">
      <div class="col-md-6">
        <div class="form-group">
          <label for="validfrom" class="control-label">Document Valid From </label>
          <kendo-datepicker [format]="format" formControlName="validfrom" [min]="startdate"
            (valueChange)="onFromDateChange($event)"> </kendo-datepicker>
          <div *ngFor="let validation of validations.message.isRequired">
            <div class="k-tooltip k-tooltip-validation " *ngIf="docuploadForm.get('validfrom').hasError(validation.type)
             && (docuploadForm.get('validfrom').dirty || docuploadForm.get('validfrom').touched)">
              Please Valid From Date
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="validupto" class="control-label">Document Valid Upto </label>
          <kendo-datepicker [format]="format" formControlName="validupto" [min]="enddate"> </kendo-datepicker>
          <div *ngFor="let validation of validations.message.isRequired">
            <div class="k-tooltip k-tooltip-validation " *ngIf="docuploadForm.get('validupto').hasError(validation.type)
             && (docuploadForm.get('validupto').dirty || docuploadForm.get('validupto').touched)">
              Please Valid To Date
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!IsViewPage">
      <div class="col-md-6">
        <div class="form-group">
          <label for="remarks" class="control-label">Remarks</label>
          <textarea type="text" formControlName="remarks" class="k-textbox" style="width: 173px"
            (keyup)="changestart($event.target.value)"></textarea>
  
          <div class="k-tooltip k-tooltip-validation" *ngIf="docuploadForm.get('remarks').hasError('maxlength')">
            Max Length of Remarks should be 250.
          </div>
          <div class="k-tooltip k-tooltip-validation" *ngIf="docuploadForm.get('remarks').hasError('minlength')">
            Min Length of Remarks should be 2.
          </div>
          <div class="k-tooltip k-tooltip-validation" *ngIf="docuploadForm.get('remarks').hasError('LastCharError')">
            Must contain only letters and numbers with spaces in between
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="IsReminder">
        <div class="form-group" *ngIf="IsViewDoc">
          <label for="documentreminder" class="control-label" style="width: 71%;">Document Renewal Reminder</label>
          <input class="k-textbox" type="number" formControlName="documentreminder"
            onkeypress="if (this.value.length > 2) return false;" style="width: 92px;" (keyup)="OnKeyUP($event)"
            pattern="^[1-9][0-9]*$" min=1  max="999"/>&nbsp;
          <kendo-dropdownlist #ddl="" popupAnchor [defaultItem]="{value: null,text: 'Select UOM'}" [data]="listuom"
            [kendoDropDownFilter]="filterSettings" [filterable]="true" [textField]="'text'" [valueField]="'value'"
            [valuePrimitive]="true" formControlName="uom">
          </kendo-dropdownlist>
          <div *ngFor="let validation of validations.message.isNumericRequired">
            <div class="k-tooltip k-tooltip-validation" *ngIf="docuploadForm.get('documentreminder').hasError(validation.type) && 
                (docuploadForm.get('documentreminder').dirty || docuploadForm.get('documentreminder').touched)">
              Must contain only numbers
            </div>
          </div>
          <div *ngFor="let validation of validations.message.isRequired">
            <div class="k-tooltip k-tooltip-validation"
              *ngIf="docuploadForm.get('uom').hasError(validation.type) && (docuploadForm.get('uom').dirty || docuploadForm.get('uom').touched)">
              Please Select UOM
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!IsViewPage">
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="control-label" style="width: 71%;">File Upload<span class="required">*</span></label>
          <input type="file" #file placeholder="Choose file" formControlName="filename" required
            (change)="onImageChangeFromFile($event)">
          <br>
          <button type="submit" class="btn btn-success uploadbtn" [disabled]="!docuploadForm.valid || !flagSize"
            (click)="uploadFile(file.files)">File Upload</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table class="table table-hover table-condensed table-bordered">
          <thead>
            <th>Document Name</th>
            <th *ngIf="IsViewDoc">Document ID</th>
            <th *ngIf="IsViewDoc">Valid From</th>
            <th *ngIf="IsViewDoc">Valid Upto</th>
            <th>Remarks</th>
          </thead>
          <tbody>
            <span *ngIf="fileslist==''">{{'No Records Available'}}</span>
            <tr *ngFor=" let item of fileslist">
              <td class="filegroup">{{item.filegroup}}<br> <span style="color:blue">{{item.filename}} </span>
                <button class="button download" (click)="download(item.filename)"><span
                    class="k-icon k-i-download"></span></button>
                &nbsp; <button class="button download" (click)="deleteDocument(item.id,item.parentid)"><span
                    class="k-icon k-i-close" *ngIf="!IsViewPage"></span></button>
              </td>
              <td *ngIf="IsViewDoc">{{item.documentid}}</td>
              <td *ngIf="IsViewDoc">{{item.validfrom | date:'dd-MM-yyyy'}}</td>
              <td *ngIf="IsViewDoc">{{item.validupto | date:'dd-MM-yyyy'}}</td>
              <td>{{item.remarks}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>